<template>
  <div class="box commentdiv">
    <article class="media">
      <figure class="media-left">
        <p class="image is-64x64">
          <img src="icons8-user-80.png" />
        </p>
      </figure>
      <p>
        <span class="user">{{ comment.username }} </span>
        <span class="time"> {{ comment.datetime }} </span>
        <br />
        <span class="comment"> {{ comment.comment }} </span>
      </p>
    </article>
  </div>
</template>

<script>
export default {
  name: "CommentCard",
  props: ["comment"]
};
</script>

<style scoped>
.commentDiv {
  font-family: "Comic Sans", Helvetica, Arial, sans-serif;
  background-color: white;
  width: 20%;
  text-align: center;
}
.user {
  font-weight: bold;
}

.time {
  font-size: smaller;
}

.commentdiv {
  margin: 5px;
}
</style>
